/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filter_Is_BlockedInputs */

const en_filter_is_blocked = /** @type {(inputs: Filter_Is_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`blocked`)
};

const de_filter_is_blocked = /** @type {(inputs: Filter_Is_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`blockiert`)
};

/**
* | output |
* | --- |
* | "blocked" |
*
* @param {Filter_Is_BlockedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const filter_is_blocked = /** @type {((inputs?: Filter_Is_BlockedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filter_Is_BlockedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_filter_is_blocked(inputs)
	return en_filter_is_blocked(inputs)
});